export default __webpack_public_path__ + "static/media/cryptocube-logo.d0e25097.png";